export const BUYER = 'buyer';
export const SELLER = 'seller';
export const BUYERS = 'buyers';
export const SELLERS = 'sellers';
export const FULFILLERS = 'fulfillers';
export const MERCHANTS = 'merchants';
